import SidebarPublication from "./SidebarPublication";

export default SidebarPublication;
